import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import Box from '@mui/material/Box'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useMutation } from '@tanstack/react-query'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

export default function CreateWebhookPix() {
  const navigate = useNavigate()
  const { openSuccessToast, openErrorToast } = useGlobalState()

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<InterReservationWebhookPixApiRequest>()

  const createWebhookPix = useMutation({
    mutationFn: async (data: InterReservationWebhookPixApiRequest) => {
      await ApiService.InterReservation.createWebhookPix(data)
    },
    onSuccess: () => {
      openSuccessToast({
        message: 'Webhook PIX criado com sucesso!',
      })
      navigate(ROUTES.INTER_RESERVATION.CREATE_WEBHOOK_PIX)
    },
    onError: () => {
      openErrorToast({
        message: 'Erro ao criar webhook PIX!',
      })
    },
  })

  return (
    <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
      <Container maxWidth={false}>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<NavigateNextIcon fontSize="small" />}
        >
          <Link
            underline="hover"
            color="inherit"
            href={ROUTES.INTER_RESERVATION.CREATE_WEBHOOK_PIX}
          >
            Inter Reservervation
          </Link>
          <Typography color="text.primary">Webhook PIX</Typography>
        </Breadcrumbs>

        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ArrowBackIcon
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(-1)
              }}
            />
            <Typography sx={{ m: 1 }} variant="h4">
              Criar Webhook PIX
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 3 }}>
          <form
            onSubmit={handleSubmit(
              (data: InterReservationWebhookPixApiRequest) => {
                createWebhookPix.mutate(data)
              },
            )}
          >
            <Card>
              <CardContent>
                <Grid container spacing={3} xs={12}>
                  <Grid item xs={6}>
                    <TextField
                      error={!!errors.chave?.message}
                      fullWidth
                      helperText={errors.chave?.message}
                      label="Chave"
                      margin="normal"
                      variant="outlined"
                      {...register('chave', { required: true })}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      error={!!errors.webhookUrl?.message}
                      fullWidth
                      helperText={errors.webhookUrl?.message}
                      label="Webhook URL"
                      margin="normal"
                      variant="outlined"
                      {...register('webhookUrl', { required: true })}
                    />
                  </Grid>
                </Grid>

                <Box>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    style={{
                      marginLeft: 'auto',
                      display: 'block',
                      marginTop: '1em',
                    }}
                  >
                    Criar
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </form>
        </Box>
      </Container>
    </Box>
  )
}
